@if (sharedData) {
  <app-shared-notification-settings [name]="'taskSummary'"
  [notificationConfig]="notificationConfig"></app-shared-notification-settings>
}
<div class="doc-actions">
  @if (showOnDemandLoader) {
    <mat-spinner diameter="20" mode="indeterminate" strokeWidth="2" value="100"
    class="overlay-spinner-preview-on-demand"></mat-spinner>
  }
  <button class="doc-actions-button-container" (click)="notificationSettings()" matTooltip="Task Notification Settings">
    <img alt="settings" [src]="'images/settings.svg' | assetUrl" class="icon-mr-5" />
    <span class="title">Task Notification Settings</span>
  </button>
</div>
<div class="summary-container">
  <div class="search-container">
    <input type="text" [(ngModel)]="searchText" placeholder="Search" autocomplete="off">
    <span (click)="searchSubmit(selectedTabIndex)" (keypress)="searchSubmit(selectedTabIndex)">
      <img alt="search" [src]="'images/search.svg' | assetUrl" class="search-icon cursor-pointer"
        draggable="false">
      </span>
    </div>
    <div class="tab-container">
      <mat-tab-group class="mat-tab-group-container" [(selectedIndex)]="selectedTabIndex"
        (selectedTabChange)="tabChanged()">
        @for (tabLabel of tabLabels; track tabLabel) {
          <mat-tab [label]="tabLabel">
            <div class="tab-container-data" infiniteScroll [infiniteScrollDistance]="5"
              [infiniteScrollThrottle]="50" (scrolled)="getSpecificTabDataOnDemandScroll(selectedTabIndex)"
              [scrollWindow]="false">
              @if (filteredSummaryData && filteredSummaryData.length === 0 && isSummaryDataLoaded) {
                <div class="summary-container-no-data"
                  > No data
                  found
                  {{summaryData[selectedTabIndex].searchTextData ? searchMsg : ""}}
                </div>
              }
              @for (record of this.filteredSummaryData; track record) {
                <div class="summary-item" (click)="handleSummaryItemClick(record)"
                  (keypress)="handleSummaryItemClick(record)">
                  <div>
                    <img alt="image view" [src]="'images/' + record.imgUrl + '.svg' | assetUrl"
                      class="cursor-pointer" draggable="false">
                    </div>
                    <div class="summary-item-content">
                      <div class="description">
                        @switch (record.contentType) {
                          @case ('FILE') {
                            <h6 class="bold-name">{{record.fileName}}</h6>
                            @if (record.kind === 'note') {
                              <span [innerHTML]="record?.displayContent"></span>
                            }
                          }
                          @default {
                            @if (record.shortDescription) {
                              <h6 class="bold-name"
                                [innerHTML]="record.shortDescription">
                              </h6>
                            }
                            <span [innerHTML]="record?.displayContent"></span>
                          }
                        }
                      </div>
                      <small class="details">
                        <!-- <img [src]="'images/' + (record?.userProfileImage ? record?.userProfileImage : 'user') + '.svg' | assetUrl"
                        class="cursor-pointer" /> -->
                        <app-user-thumb-nail [userEmail]="record.modifiedByName"
                        class="cursor-pointer user-img"></app-user-thumb-nail>
                        {{record.modifiedAt + "Z" | date: "short"}}
                        <span>&nbsp;by {{record.modifiedByName}} in {{record.accountName}}</span>
                      </small>
                    </div>
                  </div>
                }
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
    @if (showLoader) {
      <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
    }